export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10903.52a18209.jpg";